import { useElementSize } from '@/shared/hooks/use-element-size'

export function useContainerWidth<T extends HTMLElement>() {
  const { ref, width } = useElementSize<T>()
  return { ref, width }
}
